module.exports = __webpack_public_path__ + "static/assets/62085ffac735bbbaad2d067f675a2fc9.svg";